__turbopack_context__.v({
  "list": "list-module__uxXDFW__list",
});
